import script from "./LegalEntities.vue?vue&type=script&setup=true&lang=js"
export * from "./LegalEntities.vue?vue&type=script&setup=true&lang=js"

import "./LegalEntities.vue?vue&type=style&index=0&id=3f4ee5e2&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3f4ee5e2"]])

export default __exports__